var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMobileMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318270"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2864",
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2865",
    y: 6,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2866",
    y: 12,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileMenu);
export default __webpack_public_path__ + "static/media/icon-mobile-menu.02efa929d0a2a262cbbbec0c2af142b7.svg";
export { ForwardRef as ReactComponent };